<div
  class="floating-textarea-wrapper flex flex-col"
  [ngClass]="{
    'mb-2 mt-6': verticalSpacing(),
  }"
>
  <textarea
    #textAreaElement
    class="resize-none"
    [ngClass]="{
      invalid: ngControl()?.invalid && ngControl()?.touched,
    }"
    [rows]="rows"
    [cols]="cols"
    (input)="onModelChange($event)"
    [placeholder]="placeholder() || ''"
    [required]="required()"
    [value]="value()"
    [disabled]="disabled()"
    (blur)="onBlur()"
    (focus)="onFocus()"
  ></textarea>

  @if (label()) {
    <label (click)="textAreaElement.focus()" [htmlFor]="textAreaElement">
      {{ label() }}
      @if (required() === false) {
        <span class="optional-text">(optional)</span>
      }
    </label>
  }
  <small [ngClass]="{ hidden: control()?.valid || control()?.untouched }" class="p-error text-uppercase">
    @if (control()) {
      <!--      todo there might be a situation with multiple errors, this should be handled-->
      @if (control().hasError('required')) {
        Required
      }
      @if (control().hasError('pattern')) {
        Invalid
      }
      @if (control().hasError('notMatched')) {
        Does not match
      }
    }
  </small>
</div>
